import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function OpeningHook() {
  return <section className="bg-white py-24 px-6" data-id="element-47">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="max-w-3xl mx-auto text-center" data-id="element-48">
        <p className="font-serif italic text-2xl md:text-3xl leading-relaxed text-brown-dark mb-8" data-id="element-49">
          "Estás en el supermercado o en una reunión familiar. De repente, tu
          hijo explota. Gritos, llanto incontrolable y todas las miradas se
          posan sobre ti. Sientes ese calor en el cuello, la vergüenza que sube
          y, sobre todo, una impotencia profunda."
        </p>
        <p className="text-lg text-brown leading-relaxed" data-id="element-50">
          Intentas razonar, pero no escucha. Intentas amenazar, pero grita más
          fuerte. Terminas gritando tú también y, al llegar a casa, el silencio
          que queda es peor que el ruido: es el silencio de la culpa.
        </p>
      </motion.div>
    </section>;
}
export function ProblemSection() {
  return <section className="bg-cream-dark py-24 px-6" data-id="element-51">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="max-w-4xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-53">
          El verdadero problema
        </h2>
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-soft" data-id="element-54">
          <p className="text-lg text-brown leading-relaxed mb-6" data-id="element-55">
            El problema no es que seas un "mal padre" o que tu hijo sea
            "manipulador".{' '}
            <strong className="text-brown-dark font-semibold" data-id="element-56">
              El problema es que te han enseñado a apagar incendios con bencina.
            </strong>
          </p>
          <p className="text-lg text-brown leading-relaxed" data-id="element-57">
            Nos dijeron que el "tiempo fuera" o ignorarlos era la solución, pero
            eso solo rompe el vínculo y aumenta la ansiedad del niño. Cuando un
            niño entra en berrinche, su cerebro lógico se apaga. No es que "no
            quiera" escucharte, es que físicamente NO PUEDE. Estás tratando de
            enseñarle a nadar a alguien que se está ahogando.
          </p>
        </div>
      </motion.div>
    </section>;
}
export function FailedMethodsSection() {
  const methods = ['El "Tiempo Fuera" forzado solo le enseña que cuando más sufre, tú lo abandonas.', 'Los gritos activan el instinto de ataque/defensa en su cerebro, escalando el conflicto.', 'Los sobornos ("si te callas te doy un dulce") entrenan a su cerebro para usar el berrinche como moneda de cambio.', 'Ignorarlos genera una herida de rechazo que se manifiesta en problemas de conducta más graves a futuro.'];
  const container = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-white py-24 px-6" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <motion.h2 initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-60">
          Lo que ya intentaste (y por qué no funcionó)
        </motion.h2>

        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4" data-id="element-61">
          {methods.map((method, index) => <motion.div key={index} variants={item} className="flex items-start p-6 bg-cream rounded-xl border border-cream-dark" data-id="element-62">
              <XCircleIcon className="w-6 h-6 text-dusty-red flex-shrink-0 mt-1 mr-4" data-id="element-63" />
              <p className="text-lg text-brown" data-id="element-64">{method}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}